<template>
  <div class="cenario-nav">
    <div @click="invertDirection()" v-b-tooltip.hover :title="txtTooltip" class="button-nav">
      <div v-if="exibeCarregando">
        <i class="fas fa-spinner fa-spin"></i>
      </div>
      <font-awesome-icon v-else :icon="'arrow-' + direction" />
    </div>
  </div>
</template>

<script>
export default {
  name: "NavCenario",
  props: {
    leftArrow: Function,
    rightArrow: Function,
    idCenarioSelecionado: Number | String,
    exibeCarregando: Boolean
  },
  data() {
    return {
      direction: "right",
      txtTooltip: "Navegar entre Cenários"
    };
  },
  methods: {
    invertDirection: function() {
      if (this.exibeCarregando) {
        return;
      }
      if (this.direction == "right") {
        this.rightArrow();
      } else if (this.direction == "left") {
        this.leftArrow();
      }
    }
  },
  watch: {
    idCenarioSelecionado: function(newValue, oldValue) {
      this.direction = newValue == 1 ? "right" : "left";
    }
  }
};
</script>

<style lang="scss">
.cenario-nav {
  width: 100% !important;
  height: 0px !important;
  display: flex;
  position: sticky;
  top: 10px;
  left: 0px;
  justify-content: flex-end;
  z-index: 600;
  transform: translateZ(0);
}
.button-nav {
  height: 40px;
  width: 40px;
  background: #484848;
  color: var(--branco);
  position: absolute;
  right: -30px;
  top: 185px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  font-size: 20px;
  box-shadow: 2px 2px 4px #cccccca1;
  cursor: pointer;
  user-select: none;
}
</style>
